<script setup>
import { useRoute } from 'vue-router';
import RequestPasswordLink from '@/pages/auth/forgotPassword/requestPasswordLink.vue';
import ResetPassword from '@/pages/auth/forgotPassword/resetPassword.vue';

import AuthResetLayout from '@/components/auth/authResetLayout.vue';
import partnrUpLogo from '@/assets/logo/PartnrUP_Full.svg';
import GuestLayout from '@/layouts/GuestLayout.vue';

const route = useRoute();
const token = route.query?.token ?? null;
const email = route.query?.email ?? null;
</script>

<template>
  <GuestLayout>
    <AuthResetLayout>
      <div class="tw-h-full tw-w-full tw-p-6">
        <img class="tw-mx-auto tw-w-[142px]" :src="partnrUpLogo" alt="PartnrUp" />
        <h3 class="tw-mb-3 tw-text-center tw-font-mono tw-text-lg tw-font-bold tw-text-primary-blue">
          {{ token ? 'Set your new password' : 'Reset your password' }}
        </h3>
        <template v-if="token">
          <ResetPassword :token="token" :tokenEmail="email" />
        </template>
        <template v-if="!token">
          <RequestPasswordLink />
        </template>
      </div>
    </AuthResetLayout>
  </GuestLayout>
</template>

<style scoped></style>
